import React, { Component } from 'react';
import moment from 'moment';
import { Typography } from 'antd';

import ReportTable from './ReportTable';
import { ReportIncompleteNotification, FreeReportNotification } from './Notifications';

const { Title } = Typography;

class Report extends Component {
    render() {
        const { loading, onOpenReport, products, job } = this.props;

        return (
            <div>
                <Title style={{ textAlign: 'left', margin: '10px 0 20px 0' }} level={3}>
                    Products
                </Title>
                {job && job.isIncomplete && <ReportIncompleteNotification />}
                {job && job.isFree && <FreeReportNotification />}
                <ReportTable data={products} loading={loading} onOpenReport={onOpenReport} />
            </div>
        );
    }
}

export default Report;